// src/shared/layouts/PublicLayout.tsx
import React, { ReactNode } from 'react';

interface PublicLayoutProps {
  children: ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      {children}
    </div>
  );
};

export default PublicLayout;

